import { SvgIconComponent } from '../types/svgs';

const ActivityLink: SvgIconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="7"
      viewBox="0 0 16 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.32149 3.50003C6.32159 4.16293 6.58805 4.79866 7.06225 5.2674C7.53646 5.73614 8.1796 5.99952 8.85023 5.99962H12.4269C12.7627 6.00539 13.0963 5.945 13.4082 5.82197C13.7201 5.69895 14.0041 5.51575 14.2436 5.28307C14.4832 5.05039 14.6734 4.77289 14.8033 4.46675C14.9331 4.16062 15 3.83199 15 3.50003C15 3.16808 14.9331 2.83944 14.8033 2.53331C14.6734 2.22718 14.4832 1.94967 14.2436 1.71699C14.0041 1.48431 13.7201 1.30112 13.4082 1.17809C13.0963 1.05506 12.7627 0.994673 12.4269 1.00044L11.442 1M9.5906 3.50003C9.5905 2.83713 9.32405 2.20141 8.84984 1.73267C8.37564 1.26392 7.7325 1.00054 7.06187 1.00044L3.48516 1.00044C2.82211 1.01183 2.19011 1.28019 1.72529 1.74772C1.26046 2.21524 1 2.84452 1 3.50003C1 4.15554 1.26046 4.78482 1.72529 5.25235C2.19011 5.71987 2.82211 5.98823 3.48516 5.99962H4.46876"
        stroke="#394642"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActivityLink;
